<template>
    <div class="main-content">
        <b-card no-body class="shadow-none bg-transparent">
            <date-picker></date-picker>
        </b-card>
        <list
            :columns="columns"
            :rows="records"
            :select-options="{
                enabled: false,
            }"
            :pagination-options="{
                perPage: 20,
            }"
            :loading="loading"
            class="mt-3"
        />
    </div>
</template>

<script>
import api from '@/api/api'
import auth from '@/firebase/auth'

export default {
    name: 'ReportFeedbacks',
    components: {
        DatePicker: () => import('@/components/datePicker'),
        List: () => import('@/components/List/List'),
    },
    data () {
        return {
            loading: false,
            records: [],
            columns: [
                {
                    label: 'Data e Hora',
                    field: 'createdDate',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd HH:mm',
                    dateOutputFormat: 'dd/MM/yyyy HH:mm',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: 'Quantidade de Respostas',
                    field: 'descriptionCounter',
                    type: 'number',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: '',
                    field: 'visualize',
                    sortable: false,
                    tdClass: 'text-center',
                    attribute: 'qualquer',
                },
            ],
        }
    },
    methods: {
        loadData () {
            this.loading = true
            auth
                .currentUser
                .getIdToken()
                .then((token) => {
                    api
                        .get('/reports/feedbacks-home', {
                            params: {
                                range: this.range,
                            },
                            headers: {
                                token,
                            },
                        })
                        .then(response => {
                            this.loading = false

                            if (!response.data || !response.data.length) return

                            response.data = response.data.filter(record => record.descriptionCounter > 0)
                            this.records = response.data.reverse()
                        })
                })
                .catch(err => console.log(err))
        },
    },
    computed: {
        range () {
            return this.$store.getters['dashboard/range']
        },
    },
    watch: {
        range: {
            immediate: true,
            handler () {
                this.loadData()
            },
        },
    },
}
</script>
